import {useAxiosPlugin} from '@/core/plugins/axios';
import apiConstants from '@/core/constants/apiConstants';

export const useQueryRepository = () => {
    async function getQueryList(chartType) {
        try {
            const {data} = await useAxiosPlugin().httpGet(apiConstants.CHARTS_QUERY, {chart_type: chartType});
    
            return data;
        } catch (error) {
            console.error(error);
        }
    }
    
    async function getQuery(query_id) {
        try {
            const {data} = await useAxiosPlugin().httpGet(apiConstants.CHARTS_QUERY_BY_ID(query_id));
    
            return data;
        } catch (error) {
            console.error(error);
        }
    }
    
    async function createQuery(payload) {
        try {
            const {data} = await useAxiosPlugin().httpPost(apiConstants.CHARTS_QUERY, payload);
    
            return data;
        } catch (error) {
            console.error(error);
        }
    }
    
    async function updateQuery(query_id, payload) {
        try {
            const {data} = await useAxiosPlugin().httpPost(apiConstants.CHARTS_QUERY_BY_ID(query_id), payload);
    
            return data;
        } catch (error) {
            console.error(error);
        }
    }
    
    async function deleteQuery(query_id) {
        try {
            const {data} = await useAxiosPlugin().httpDelete(apiConstants.CHARTS_QUERY_BY_ID(query_id));
    
            return data;
        } catch (error) {
            console.error(error);
        }
    }
    
    return {
        getQueryList,
        getQuery,
        createQuery,
        updateQuery,
        deleteQuery,
    };
};
